module.exports = __webpack_public_path__ + "img/adhibition-2.85d2742.png";